// src/services/api.ts

import axios from 'axios';

// Create an instance of axios with default settings
const apiClient = axios.create({
  baseURL: 'http://127.0.0.1:8000', // Your backend base URL
  timeout: 6000000, // Request timeout in milliseconds
});

// Function to breakdpwn a problem by calling the backend
export const BreakdownProblem = async (problemData: { problemId: string; userId: string }) => {
  try {
    const payload = {
      firebase_user_id: problemData.userId,
      firebase_problem_id: problemData.problemId,
    };

    console.log('Sending problem data to backend:', problemData);
    const response = await apiClient.post('/api/v0/problem-solver/task-breakdown', payload);

    console.log('Received response from backend:', response.data);

    return response.data; // Return the backend response data
  } catch (error) {
    console.error('Error occurred while solving problem:', error);

    // Throw the error so it can be caught in the calling function
    throw error;
  }
};

// Function to process tasks after breakdown
export const ProcessTasks = async (problemData: { problemId: string; userId: string }) => {
  try {
    const payload = {
      firebase_user_id: problemData.userId,
      firebase_problem_id: problemData.problemId,
    };

    console.log('Sending task processing request to backend:', problemData);
    const response = await apiClient.post('/api/v0/problem-solver/task-processing', payload);

    console.log('Received processing results from backend:', response.data);

    return response.data;
  } catch (error) {
    console.error('Error occurred while processing tasks:', error);
    throw error;
  }
};

// Function to consolidate expert work and generate final document
export const ConsolidateAndGenerateFinal = async (problemData: {
  problemId: string;
  userId: string;
}) => {
  try {
    const payload = {
      firebase_user_id: problemData.userId,
      firebase_problem_id: problemData.problemId,
    };

    console.log('Sending consolidation request to backend:', problemData);
    const response = await apiClient.post(
      '/api/v1/problem-solver/generate-final-document',
      payload
    );

    console.log('Received consolidation results from backend:', response.data);

    return response.data;
  } catch (error) {
    console.error('Error occurred while consolidating results:', error);
    throw error;
  }
};
